function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.484 10.014c-.738-2.087 1.37-4.05 3.4-3.165l13.227 5.765c2.027.884 2.027 3.76 0 4.643L4.883 23.023c-2.03.884-4.137-1.078-3.399-3.165l1.415-4.005h8.438a.974.974 0 000-1.948H2.86l-1.375-3.89z",
  fill: "#FCFCFC"
})));